import * as React from 'react';
import './index.css';
import { Swiper } from '@wmfe/mach-pro-components-react';
import { isEqual } from 'lodash';

interface picData {
  url?: string;
  scheme?: string;
}

interface ISwiperProps {
  pictures: picData[];
  shopStatus?: any;
  imgTopContent?: any;
  brandLogo?: string;
  style: any;
  clickToDetail?: (scheme?: string) => void;
  disableMask?: any;
}

interface ISwiperState {
  currentIndex: number;
}

export default class PicturesSwiper extends React.Component<ISwiperProps, ISwiperState> {
  swiperView: any = null

  constructor(props: ISwiperProps) {
    super(props);
    this.state = {
      currentIndex: 0,
    };
  }

  componentDidUpdate(prevProps: Readonly<ISwiperProps>): void {
    const dataChanged = !isEqual(this.props?.pictures, prevProps?.pictures) || !isEqual(this.props?.shopStatus, prevProps?.shopStatus) || !isEqual(this.props?.imgTopContent, prevProps?.imgTopContent);
    if (dataChanged) {
      this.setState({
        currentIndex: 0,
      }, () => {
        this.swiperView?.reload?.();
      });
    }
  }

  render() {
    const {
      shopStatus, pictures, brandLogo, disableMask
    } = this.props;
    return (
      <view
        className="product-pic-swiper-container"
        style={{ height: '100%' }}
      >
        {/* 图片滚动 */}
        <Swiper
          ref={(ref: any) => { this.swiperView = ref; }}
          itemCount={() => pictures.length}
          direction="horizontal"
          autoPlay={false}
          infinite={pictures.length > 1}
          scrollable={pictures.length > 1}
          alignment="center"
          renderItem={(cellInfo) => this.renderItem(pictures?.[cellInfo.index])}
          onDidScrollToItem={(index: number) => {
            this.onDidScrollToItem(index);
          }}
        />

        {/* 图片蒙层 */}
        {!disableMask && <view className="product-pic-bottom-mask" />}

        {/* logo */}
        {brandLogo && (
          <image
            className="product-pic-top-brandPic" src={brandLogo} placeholder="assets://placeholder/icon_placeholder_1:1.png"
          />
        )}

        {/* 数字指示器 */}
        {this.props.pictures.length > 1 && (
          <view className="product-pic-number-indicator">
            <text
              className="product-pic-number-indicator-text"
              content={`${this.state.currentIndex + 1}/${this.props.pictures.length}`}
            />
          </view>
        )}

        {/*营业状态：营业中-3；休息中-4*/}
        {!disableMask && shopStatus && shopStatus?.shopStatusCode === 4 && (
          <view className="product-pic-container">
            <view className="product-pic-cover" />
            <view className="product-pic-text-container">
              {shopStatus?.shopStatusDesc && <text className="product-pic-title" content={shopStatus?.shopStatusDesc} />}
              {shopStatus?.nextBusinessHour && <text className="product-pic-title" style={{ paddingTop: shopStatus?.shopStatusDesc ? 4 : 0 }} content={shopStatus?.nextBusinessHour} />}
            </view>
          </view>
        )}
      </view>
    );
  }

  renderItem = (item: picData) => (
    <view
      key={item?.url} style={{ ...this.props?.style }} onClick={() => {
        this.onBannerClick(item?.scheme);
      }}
    >
      <image
        style={{ height: '100%', width: '100%', resizeMode: 'aspectFill' }}
        src={item?.url || ''}
        placeholder="assets://placeholder/icon_placeholder_16:9.png"
        error="assets://placeholder/icon_placeholder_16:9.png"
      />
    </view>
  )

  private onDidScrollToItem = (index: number) => {
    this.setState({
      currentIndex: index,
    });
  }

  private onBannerClick = (scheme?: string) => {
    if (this.props?.clickToDetail) {
      this.props.clickToDetail(scheme);
    }
  }
}
